var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.errors.google,
          expression: "!errors.google",
        },
      ],
      staticClass: "flex justify-center pb-3",
      attrs: { id: "googleSignIn" },
    }),
    _vm._v(" "),
    _vm.errors.google
      ? _c(
          "div",
          { staticClass: "flex justify-center error--text text-sm mb-6" },
          [_vm._v("\n        " + _vm._s(_vm.errors.google) + "\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.divider && !_vm.errors.google
      ? _c(
          "div",
          { staticClass: "mt-3" },
          [
            _c("v-divider", { staticClass: "mx-auto", attrs: { inset: "" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex justify-center",
                staticStyle: { transform: "translateY(-13px)" },
              },
              [
                _c("v-sheet", { staticClass: "w-10 white" }, [
                  _c(
                    "div",
                    { staticClass: "font-bold soli-grey flex justify-center" },
                    [_vm._v("\n                    or\n                ")]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }